import React from 'react'
import WebContainer from '../../Containers/WebContainer'
import TelecelFooterLogo from '../../SVG/mobile/telecel_footer_logo'
import { navigate } from 'gatsby'

const WebFooter =  ({footerData}) => {

 
  return (
    <footer className="hidden md:block bg-black  mt-25">
     <WebContainer>
      <div className='py-5'>
      <div className='w-full flex items-start gap-10'>
        <div className='w-2/12 py-4'>
          <TelecelFooterLogo/>
        </div>
        <div className='w-10/12'>
          <ul className='w-full h-full grid grid-cols-4'>
            {footerData.map((item, index)=>{
               const { id, title, children } = item;
               return (
                <div key={index} className=''>
                <li className='text-footnote text-white font-bold py-4'>{title}</li>
                {children.map((item, index)=>{
                  const { title, link } = item;
                  return (
                    <li key={index} className='text-subtitle text-white py-2 hover:text-brand transition cursor-pointer' onClick={() => navigate(link)}>{title}</li>
                  )
                })}
                </div>
               )
            })}
          </ul>
        </div>
      </div>
      </div>
      </WebContainer>
    </footer>
  )
}

export default WebFooter